module.exports = __webpack_public_path__ + "img/kj1.8fce92c1.png";